import { useFormatPenceFactory } from "$routes/_lib/use-format-pence";
import { useMemo } from "react";
import { array, number, object, string } from "yup";
import { TRANSACTION_TOTAL } from "../components/formConstants";

const paymentTypeOptions = [
  { label: "Cash", value: "CASH" },
  { label: "Waiver", value: "WAIVER" },
];

export const useTransactionsSchema = ({
  totalPayableInPence,
  minValue = 1,
}) => {
  const formatPence = useFormatPenceFactory();

  return useMemo(
    () =>
      object({
        transactions: array()
          .of(
            object({
              amountInPence: number().min(minValue).required(),
              type: string(),
              method: string()
                .oneOf(paymentTypeOptions.map(({ value }) => value))
                .required(),
            }),
          )
          .min(1)
          .test(
            TRANSACTION_TOTAL,
            `Total amount must not exceed ${formatPence(totalPayableInPence)}`,
            function testTotal(transactions) {
              let waiveAmount = 0;
              const transactionTotal = transactions.reduce(
                (totalInPence, { amountInPence, type }) => {
                  if (type === "WAIVER") {
                    waiveAmount = amountInPence;
                  }
                  return totalInPence + amountInPence;
                },
                0,
              );

              const isValid =
                transactionTotal > 0 && transactionTotal <= totalPayableInPence;

              if (isValid) {
                return true;
              }

              if (transactionTotal <= 0) {
                return this.createError({
                  path: TRANSACTION_TOTAL,
                  message: `Total amount must be greater than ${formatPence(
                    0,
                  )}`,
                });
              }

              return this.createError({
                path: TRANSACTION_TOTAL,
                message: `Total amount must not exceed ${formatPence(
                  totalPayableInPence - waiveAmount,
                )}`,
              });
            },
          ),
      }),
    [totalPayableInPence, minValue, formatPence],
  );
};
